import type { Id } from '@e-socna/data-layer';

import type { FileItem } from '../types/file-item.type';

export interface DerivedFilesInfo {
  readonly compressedFile: FileItem | null;
  readonly hasThumbnail: boolean;
}

export const getDerivedFilesInfo = (
  file: Readonly<FileItem>,
  filesById: ReadonlyMap<Id, FileItem>,
): DerivedFilesInfo => ({
  compressedFile: file.compressedVariantId
    ? (filesById.get(file.compressedVariantId) ?? null)
    : null,
  hasThumbnail:
    !!file.thumbnailVariantId && filesById.has(file.thumbnailVariantId),
});
